export default defineNuxtRouteMiddleware(() => {
	if (process.server) return

	const nuxtApp = useNuxtApp()
	const isLogged = useCookie('is_logged')
	const userStore = useUserStore()

	if (isLogged.value && !userStore.state.user) {
		userStore.fetchUser().catch(() => {
			nuxtApp.runWithContext(() => userStore.logout())
		})
	} else if (!isLogged.value && userStore.state.user) {
		nuxtApp.runWithContext(() => userStore.logout())
	}
})
